module.exports = __webpack_public_path__ + "static/kiteSketchOne-e8840158156c97fced3e0d95ec350d2c.png";